import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/facebook-cancellations-and-refunds';

export default function Example() {
  return (
    <>
      <Head>
        <title>A Seller's Guide to Dealing with Facebook Marketplace Cancellations and Refunds Safely</title>
        <meta
          name='description'
          content="Aside from managing refunds, there's more at stake for sellers when orders get canceled on FB Marketplace. Fortunately, there are ways to handle these situations well with minimized risks. Read our tips and tricks below."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/facebook-cancellations-and-refunds' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/facebook-cancellations-and-refunds' />
        <meta
          property='og:title'
          content="A Seller's Guide to Dealing with Facebook Marketplace Cancellations and Refunds Safely"
        />
        <meta
          property='og:description'
          content="Aside from managing refunds, there's more at stake for sellers when orders get canceled on FB Marketplace. Fortunately, there are ways to handle these situations well with minimized risks. Read our tips and tricks below."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
